import { render } from "./PGMofTexasView.vue?vue&type=template&id=91cede3e&ts=true"
import script from "./PGMofTexasView.vue?vue&type=script&lang=ts"
export * from "./PGMofTexasView.vue?vue&type=script&lang=ts"

import exportComponent from "/src/ceotrammell_/ceotrammell-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__